"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@mui/material/styles");
var Slider_1 = __importDefault(require("shared/components/Slider"));
exports.default = (0, styles_1.styled)(Slider_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'offsetLeft'; },
})(function (_a) {
    var offsetLeft = _a.offsetLeft, theme = _a.theme;
    return ({
        width: 'calc(100% + 42px)',
        marginLeft: theme.spacing(-5.25),
        '& a:hover': {
            textDecoration: 'none',
        },
        '& > div:first-of-type': {
            left: offsetLeft || 0,
        },
        '.MuiTabs-scrollButtons:first-child::before': (offsetLeft && ({
            content: '""',
            display: 'block',
            height: '100%',
            backgroundColor: theme.palette.common.white,
            width: offsetLeft,
            left: -offsetLeft,
            zIndex: 999,
            position: 'absolute',
        })),
    });
});
